<template lang="pug">
div
	.m-2(v-for="texto in version.textos" :key="texto.ID_texto")
		.card
			div(style="position:relative;display:table;width:100%;" :class="(texto.tipo === 'tec') ? 'bg-warning' : 'bg-light'")
				.p-1(style="display:table-cell;width:70px;text-align:center;")
					div(v-if="texto.tipo !== 'tec'")
						img.rounded-circle(:src="getAvatar(texto.tipo, texto.numero)" style="border:1px solid #e0e0e0; width:60px;height:60px;")
						br
						|{{texto.tipo}}{{texto.numero}}
					div(v-if="texto.tipo === 'tec'")
						span.fa.fa-info-circle(style="font-size:4em;")
				.p-1(style="display:table-cell;vertical-align:top;font-size:1.3em;" v-html="texto.texto.replace(/\\n/gm, '<br>')")
				div(style="display:table-cell;text-align:center;width:100px;padding-right:5px;vertical-align:top;padding-top:5px;")
					.input-group.input-group-sm(v-if="tarea.fase === 'pteProduccion'")
						.form-control.form-control-sm
							span(v-if="texto.grabado") Grabado
							span(v-else) Pendiente
						.input-group-btn
							button.btn.btn-sm(:class="(!texto.grabado) ? 'btn-default' : 'btn-success'" @click="setTextoGrabado(texto.ID_texto, !texto.grabado)")
								.fa.fa-check
</template>

<script>
import API from '../../services/api'

export default {
	name: 'visualiza-texto',
	props: ['version', 'tarea'],

	data: function () {
		return {

		}
	},

	computed: {

	},

	methods: {
		getAvatar (tipo, num) {
			const titulo = tipo.toString() + num.toString()

			for (let i = 0; i < this.version.locutores.length; i++) {
				if (this.version.locutores[i].titulo === titulo) {
					if (this.version.locutores[i].info !== null) {
						return this.version.locutores[i].info.avatar
					} else if (tipo === 'loc') {
						return '/static/recursos/hombre.svg'
					} else if (tipo === 'loca') {
						return '/static/recursos/mujer.svg'
					} else if (tipo === 'locx') {
						return '/static/recursos/otro.svg'
					} else {
						return '/static/recursos/hombre.svg'
					}
				}
			}
		},

		setTextoGrabado (idTexto, grabado) {
			if (this.tarea.fase === 'finalizada') {
				return
			}
			const datos = {
				ID_version: this.version.ID_version,
				ID_texto: idTexto,
				grabado: grabado
			}

			API.setTextoGrabado(datos)
				.then(res => {
					this.actualiza(res.data.version)
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		actualiza (version) {
			this.$emit('update:version', version)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/visualiza-texto.vue